import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useState } from "react";
import { Outlet } from "react-router";

import { useTranslation } from "@punto/frontend-shared/i18n/i18next";
import { isInIframe } from "@punto/frontend-shared/utils/is-iframe";
import { Button } from "@punto/ui/components/button";
import { Card } from "@punto/ui/components/card";
import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

const IframeSimpleLayout = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, loginWithPopup } = useAuth0();
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  const inIframe = isInIframe();

  const handleLogin = useCallback(async () => {
    setIsAuthenticating(true);
    try {
      await loginWithPopup();
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsAuthenticating(false);
    }
  }, [loginWithPopup]);

  // Show loading
  if (isLoading) {
    return <FullScreenLoader />;
  }

  // Show manual login button if auto-login failed
  if (!isAuthenticated && inIframe) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
        <Card className="w-full max-w-md p-8 text-center">
          <div className="mb-6">
            <h1 className="mb-2 font-display text-2xl font-bold text-foreground">
              {t("IframeSimpleLayout.auth_title")}
            </h1>
            <p className="text-sm text-muted-foreground">
              {t("IframeSimpleLayout.auth_description")}
            </p>
          </div>

          <Button
            onClick={() => void handleLogin()}
            disabled={isAuthenticating}
          >
            {isAuthenticating
              ? t("IframeSimpleLayout.authenticating")
              : t("IframeSimpleLayout.login_button")}
          </Button>
        </Card>
      </main>
    );
  }

  return <Outlet />;
};

export { IframeSimpleLayout };
